import { Grid, Link as MaterialLink, Typography } from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { FunctionComponent } from 'react';
import Translation from '../../../../../../common/components/translation/Translation';
import summaryStyles from '../summarySection/SummaryStyles';

export interface ISummaryTitle {
  setIsExpanded: (value: boolean) => void;
  isExpanded: boolean;
}

const SummaryTitle: FunctionComponent<ISummaryTitle> = ({ isExpanded, setIsExpanded }) => {
  const styles = summaryStyles();

  return (
    <Grid
      container={true}
      direction={'row'}
      alignItems={'flex-end'}
      justifyContent={'space-between'}
      className={styles.containerTitle}
    >
      <Grid item={true}>
        <Typography variant="sectionTitle">
          <Translation id={'spc.customise.title'} />
        </Typography>
      </Grid>
      <Grid item={true}>
        <MaterialLink
          onClick={() => setIsExpanded(!isExpanded)}
          data-test={'configure:summary:showFullSummary'}
          className={styles.newLink}
        >
          <Typography variant="helpingText">
            {isExpanded ? (
              <>
                <Translation id={'spc.customise.titleHide'} />
                <ExpandLessIcon className={styles.expandIcon} />
              </>
            ) : (
              <>
                <Translation id={'spc.customise.titleShow'} />
                <ExpandMoreIcon className={styles.expandIcon} />
              </>
            )}
          </Typography>
        </MaterialLink>
      </Grid>
    </Grid>
  );
};

export default SummaryTitle;
